<template>
  <b-modal id="modalEdit24TVUser" ref="modalEdit24TVUser"
      :title="$t('modalEdit24TVUser')" hide-footer size="xl" @shown="shown">

      <subs :userInfo="userInfo"/>
  </b-modal>
</template>

<script>
import subs from './userInfoSubs'

export default {
  components: {
    subs
  },
  props: {
    userInfo: null
  },
  methods: {
    shown () {
      this.$store.dispatch('Settings/GET_TV_24_USER_SUBSCRIPTIONS', this.userInfo.id)
    }
  },
  mounted () {
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/customerPortal/24tv/userInfo.vue